import fetch from "./fetch";
/**
 * 数据管理
 */
const dataManage = {
  //随访数据-分页查询
  getFollowUpList(params) {
    return fetch({
      isLoading: true,
      url: "/followUpRecord/page",
      method: "GET",
      params,
    });
  },
  /* 随访记录 */
  // 分页查询
  getFollowRecord(data) {
    return fetch({
      isLoading: true,
      url: "/followUpRecord/follow/record",
      method: "POST",
      data,
    });
  },
  // 随访详情
  getFollowDetails(id) {
    return fetch({
      isLoading: true,
      url: `/followUpRecord/follow/details?id=${id}`,
      method: "GET",
    });
  },

};

export default dataManage;
